import { Theme } from '@mui/material';
import config from '@shared/config';


const Button = (theme: Theme) => {
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: config.theme.disableRipple,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: config.theme.elevation === 0,
      },
      styleOverrides: {
        root: {
          borderRadius: '4px',
          textTransform: 'none',
          position: 'relative',
        },
      },
      variants: [
        {
          props: { variant: 'outlined', color: 'default' },
          style: {
            border: '1px solid #e2e8f0',
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: '#f1f5f9',
              borderColor: '#cbd5e0',
            },
          },
        },
      ],
    },
  };
};

export default Button;
